module.exports = __webpack_public_path__ + "img/photo-count.2e80ce54.svg";